export enum EnumCell {
  common = 'common',
  flag = 'flag',
  mine = 'mine',
  notMine = 'not_mine',
  error = 'mine_red',
  pressed = 'pressed',
  question = 'question',
  qpressed = 'question_pressed',
  cell1 = 1,
  cell2 = 2,
  cell3 = 3,
  cell4 = 4,
  cell5 = 5,
  cell6 = 6,
  cell7 = 7,
  cell8 = 8,
}

export enum SmileStatus {
  common = 'smile',
  suprise = 'smile_o',
  sad = 'smile_sad',
  success = 'smile_success',
  presed = 'smile_pressed',
}
